import { t } from "i18next";
import { validateCostPH, validateRequired } from "../../../EquipmentList/equipmentlist.functions";
import { CateringServiceRowValues } from "../Domain/Types/FacilityService-row.types";
import { checkIntegerDigits } from "./catering-list.functions";

export function validateCateringRow(row: Partial<CateringServiceRowValues>) {
  const validateValue = (isEmpty: boolean, emptyStr: string, nextCheck: string) =>
    isEmpty ? emptyStr : nextCheck;
  const validateTypeLength = (isInvalid: boolean, invalidStr: string) =>
    isInvalid ? invalidStr : "";

  const nameEmpty = t("Name cannot be empty");
  const nameExceed = t("Name cannot exceed 75 characters");
  const descEmpty = t("Description cannot be empty");
  const descExceed = t("Description cannot exceed 1000 characters");
  const ppuNaN = t("Price Per Unit should be number");
  const ppuMinus = t("Price Per Unit should be larger than 0");
  const ppuExceed = t("Price Per Unit cannot exceed 7 digits");
  const ppuEmpty = t("Price Per Unit must be bigger than 0");

  const isNameLength = validateTypeLength(row.name.length > 75, nameExceed);
  const isNameValid = validateValue(!validateRequired(row.name), nameEmpty, isNameLength);

  const isDescLength = validateTypeLength(row.description.length > 1000, descExceed);
  const isDescValid = validateValue(!validateRequired(row.description), descEmpty, isDescLength);

  const isPpuEmpty = validateCostPH(row.pricePerUnit) ? "" : ppuEmpty;
  const isPPuExceed = checkIntegerDigits(String(row.pricePerUnit)) > 7 ? ppuExceed : isPpuEmpty;
  const isPpuMinus = row.pricePerUnit < 0 ? ppuMinus : isPPuExceed;
  const isPpuValid = Number.isNaN(Number(row.pricePerUnit)) ? ppuNaN : isPpuMinus;

  return {
    name: isNameValid,
    description: isDescValid,
    pricePerUnit: isPpuValid
  };
}
